<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: "playlist-item",
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      overlay: {
        text: "",
        show: false,
        snack: false,
      },
    }
  },
  methods: {},
})
</script>

<template>
  <div>
    <v-row dense align-content="center" align="center">
      <div style="width: 50px">
        <v-img width="50" height="50" contain :src="item.image"/>
      </div>
      <strong class="black--text title text-uppercase mr-2">{{ item.name }}</strong>
    </v-row>
    <div class="mt-2">
      <v-menu offset-y v-if="!item.variants || item.variants.length === 0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn small dark rounded color="pink" v-bind="attrs" v-on="on">
            Playlist
            <v-icon right>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item link @click="() => {overlay.text = item.link ; overlay.show = true}">
            <v-list-item-title>{{ $t('iptv.show_link') }}</v-list-item-title>
            <v-list-item-icon>
              <v-icon small>mdi-eye</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item link :href="item.link">
            <v-list-item-title>{{ $t('iptv.download_file') }}</v-list-item-title>
            <v-list-item-icon>
              <v-icon small>mdi-download</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item ripple link @click="$notification.copy(item.link)">
            <v-list-item-title>{{ $t('iptv.copy_link') }}</v-list-item-title>
            <v-list-item-icon>
              <v-icon small>mdi-content-copy</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-menu>
      <div v-else>
        <v-menu offset-y v-for="v in item.variants">
          <template v-slot:activator="{ on, attrs }">
            <v-btn small dark rounded color="pink"
                   class="ml-1"
                   v-bind="attrs"
                   v-on="on">{{ v.name }}
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item ripple link @click="() => {overlay.text = v.link ; overlay.show = true}">
              <v-list-item-title>{{ $t('iptv.show_link') }}</v-list-item-title>
              <v-list-item-icon>
                <v-icon small>mdi-eye</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item link :href="v.link">
              <v-list-item-title>{{ $t('iptv.download_file') }}</v-list-item-title>
              <v-list-item-icon>
                <v-icon small>mdi-download</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item ripple link @click="copyToClipboard(v.link)">
              <v-list-item-title>{{ $t('iptv.copy_link') }}</v-list-item-title>
              <v-list-item-icon>
                <v-icon small>mdi-content-copy</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <div class="caption mt-2">{{ item.description }}</div>
    <v-overlay opacity="1" :value="overlay.show">
      <v-row justify="center" class="">
        <div class="text-center pa-6">
          <div class="text-lg-h3 text-md-h5 text-sm-h5" style="overflow-wrap: anywhere;">{{ overlay.text }}</div>
          <v-btn class="mt-2" outlined @click="overlay.show = false">
            <v-icon left>mdi-close</v-icon>
            {{ $t('base.close') }}
          </v-btn>
        </div>
      </v-row>
    </v-overlay>
  </div>
</template>

<style scoped>

</style>